import { makeStyles } from '@material-ui/core'

/**
 * Lifted verbatim from `screens/Notifications/styles/index.styles.ts`, which is the
 * implementation `portal-ux-conventions.md` §4.3 points at.
 *
 * The `Mui-selected` border is the portal's tab signature — the active tab reads as a boxed
 * surface joined to the panel below it, rather than MUI's default thin underline. Matching
 * the AppBar and the fullWidth variant gets the BAR right; this is what makes the active TAB
 * read as the same control an operator meets in Notification management.
 *
 * `borderTop: none` is what joins the tab to the bar rather than outlining it as a separate
 * box — the three-sided border is deliberate, not an omission.
 *
 * Duplicated rather than shared because the two live in different feature folders and the
 * portal has no tab-style module today. If a third tabbed section needs it, extract then —
 * two copies is where an abstraction is most likely to be the wrong one.
 */
const useStyles = makeStyles((theme) => ({
  /**
   * Separation from whatever follows, carried by the tab strip rather than by each screen.
   *
   * Nothing provided it. The strip sat flush against the next element, and the promotion
   * screens open with an outlined Select whose floating InputLabel renders ABOVE its input
   * box — so the label crossed the tab's bottom border and the two overlapped. Reported from
   * the Overview; it is the same on Why-not-applied and on the List header, because all three
   * mount this component and none of them added spacing.
   *
   * 24px is the reference implementation's figure: Notifications puts `paddingTop: 24` on the
   * panel below its strip (screens/Notifications/styles/index.styles.ts). Carried here instead
   * of on each panel so a fourth screen mounting this component cannot forget it — the copy
   * that goes missing is the one each consumer has to remember.
   */
  root: {
    marginBottom: theme.spacing(3)
  },
  tab: {
    fontSize: 14,
    '&.Mui-selected': {
      border: `3px solid ${theme.palette.primary.main}`,
      borderTop: 'none'
    }
  }
}))

export default useStyles
